(function () {
  var STORAGE_KEY = 'pavi_wishlist';

  function getWishlist() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (e) {
      return [];
    }
  }

  function setWishlist(list) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (e) {}
  }

  function toggleFavorite(handle) {
    var list = getWishlist();
    var idx = list.indexOf(handle);
    var added;
    if (idx === -1) {
      list.push(handle);
      added = true;
    } else {
      list.splice(idx, 1);
      added = false;
    }
    setWishlist(list);
    updateBadge();
    document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { list: list, handle: handle, added: added } }));
    return added;
  }

  function updateBadge() {
    var count = getWishlist().length;
    var badges = document.querySelectorAll('[data-wishlist-count]');
    badges.forEach(function (el) {
      el.textContent = count;
      el.classList.toggle('hdr-wishlist-count-empty', count === 0);
    });
  }

  function refreshHeartButtons() {
    var list = getWishlist();
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      var handle = btn.getAttribute('data-wishlist-toggle');
      var active = list.indexOf(handle) !== -1;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var handle = btn.getAttribute('data-wishlist-toggle');
    toggleFavorite(handle);
    refreshHeartButtons();
  });

  document.addEventListener('wishlist:updated', refreshHeartButtons);

  function init() {
    updateBadge();
    refreshHeartButtons();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.PaviWishlist = {
    get: getWishlist,
    isFavorited: function (handle) {
      return getWishlist().indexOf(handle) !== -1;
    },
    toggle: toggleFavorite,
    refresh: refreshHeartButtons
  };
})();
